import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/general/openItemsReportActions'
import { DatePicker, Button, Form, Checkbox, AutoComplete, Input, Icon, Spin } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/general/open-items/ListItems'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const { RangePicker } = DatePicker

const propTypes = {}
const FormItem = Form.Item
const CheckboxGroup = Checkbox.Group

class OpenItemsContainer extends Component {
  constructor(props) {
    super(props)
    const filter = [
      moment(new Date(), 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]
    // const serviceParams = {
    //   startDate: moment(filter[0]).format('YYYY-MM-DD'),
    //   endDate: moment(filter[1]).format('YYYY-MM-DD')
    // }
    this.state = {
      filter: filter,
      indeterminate: false,
      checkedList: [],
      checkAll: false,
      plainOptions: [
        'AIAs',
        'Payment Requests',
        'Invoices',
        'Material Requests',
        'Driver Requests',
        'Work Orders',
        'Service Orders',
        'Change Order Estimates',
        'Repair Order Estimates',
        'Change Orders',
        'Repair Orders',
        'Transmittals',
        'RFIs'
      ]
    }

    // get job list
    this.props.openItemsReportGetJobList({})
    // get organization list
    this.props.openItemsReportGetOrganizationList()
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.openItemsReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  onChangeCheckboxGroup = checkedList => {
    this.setState({
      checkedList,
      indeterminate: !!checkedList.length && checkedList.length < this.state.plainOptions.length,
      checkAll: checkedList.length === this.state.plainOptions.length
    })
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (!values.organization_id) {
        delete values.organization_id
      }
      if (!values.job_id) {
        delete values.job_id
      }
      this.props.openItemsReportGetFullReport({ filters: values })
    })
  }

  onCheckAllChange = e => {
    const { form } = this.props
    form.setFieldsValue({
      entities: e.target.checked ? this.state.plainOptions : []
    })
    this.setState({
      checkedList: e.target.checked ? this.state.plainOptions : [],
      indeterminate: false,
      checkAll: e.target.checked
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = {}

      if (values.date_range[0] && values.date_range[1]) {
        params.startDate = moment(values.date_range[0]).format('YYYY-MM-DD')
        params.endDate = moment(values.date_range[1]).format('YYYY-MM-DD')
      }

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/general/open-items-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'openItemsReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'openItemsReportActions.loadingJobList')

    const organizationListData = _.get(this.props, 'openItemsReportActions.organizationList.data')
    const loadingOrganizationList = _.get(
      this.props,
      'openItemsReportActions.loadingOrganizationList'
    )

    const loadingFullReport = _.get(this.props, 'openItemsReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'openItemsReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Open Items Report</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-12">
                  <FormItem label="Select the date range:">
                    {getFieldDecorator('date_range', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a first name'
                        }
                      ],
                      initialValue: this.state.filter
                    })(<RangePicker onChange={this.onChange} />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      {getFieldDecorator('job_id', {})(
                        <AutoComplete
                          onChange={this.handleJobSearch}
                          dataSource={convertToOption(jobListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Job"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
                <div className="col-6">
                  <Spin spinning={loadingOrganizationList}>
                    <FormItem label="Company">
                      {getFieldDecorator('organization_id', {})(
                        <AutoComplete
                          dataSource={convertToOption(organizationListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Company"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
            <div className="col-6">
              <FormItem label="Select entities:">
                {getFieldDecorator('entities', {
                  initialValue: this.state.checkedList
                })(
                  <CheckboxGroup
                    options={this.state.plainOptions}
                    onChange={this.onChangeCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox
                  indeterminate={this.state.indeterminate}
                  onChange={this.onCheckAllChange}
                  checked={this.state.checkAll}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ openItemsReportActions, authentication }, ownProps) => ({
  openItemsReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

OpenItemsContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(OpenItemsContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/general/OpenItemsContainer.js